import { toTitleCase } from '@mobi/utils/string'
import type { KambiEvent } from '@mobi/api-types/kambi'
import type { KambiSportsEventDetails, KambiSportsSelection } from '@mobi/betslip/types'

export const getKambiSelectionDetailsForTracking = (
  selection: KambiSportsSelection,
  selectionDetails: KambiSportsEventDetails
) => {
  const bet = selection.betSelectionType
  const events = selectionDetails.events

  const betType =
    bet === 'single'
      ? selection.betOffer.betOfferType.name
      : bet === 'same-game-multi'
        ? bet
        : `sports-${bet}`

  if (events.length === 0) {
    return { betType, sport: undefined, legs: 0 }
  }

  const sport = getSportCode(events)

  if (bet === 'multi') {
    return {
      betType,
      sport: sport,
      legs: selection.legs.length,
    }
  }

  if (bet === 'same-game-multi') {
    return { betType, sport, league: undefined, match: undefined, legs: selection.betOffers.length }
  }

  return { betType, sport, legs: 1 }
}

// =============
// Local Helpers
// =============

const getSportCode = (events: KambiEvent[]): string => {
  return events.some(event => event.sport?.toLowerCase() !== events[0].sport?.toLowerCase())
    ? 'Combination'
    : toTitleCase(events[0].sport)
}
